var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MobileMenu"},[_c('span',{on:{"click":_vm.toggleSideMenu}},[_c('MenuIcon',{staticClass:"menuIcon"})],1),_c('SideMenu',{attrs:{"menuToggler":_vm.toggleSideMenu,"isActive":_vm.menuActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }